import { ActionIcon, TextInput, TextInputProps } from "@mantine/core";
import { IconClearField } from "./Icons";

interface Props {
  setSearchText: (text: string) => void;
  searchText: string;
  textInputProps?: TextInputProps;
}

export const TextSearchBox = (props: Props) => {
  return (
    <TextInput
      mt="xs"
      placeholder="Search..."
      value={props.searchText}
      onChange={(event) => props.setSearchText!(event.currentTarget.value)}
      rightSection={
        <ActionIcon
          variant="subtle"
          size="sm"
          style={{ display: props.searchText ? "block" : "none" }}
          onClick={() => props.setSearchText!("")}
        >
          <IconClearField />
        </ActionIcon>
      }
      {...props.textInputProps}
    />
  );
};
